<template>
  <BaseTableView :head="tableHead" :class="$vuetify.breakpoint.xlOnly ? 'table' : ''">
    <template v-for="(item, key) in items">
      <StatisticProjectReportsTableItem
        :key="key"
        :item="item"
        :function_dataList="function_dataList"
        :click-line="openBillsTable"
        :bill-opened="showBills === item.id"
        :on-bill-open="openBillsModal"
      />
      <tr v-if="$vuetify.breakpoint.xlOnly" :key="'bills' + key" class="rel">
        <td v-if="showBills === item.id && bills.length > 0" colspan="6" class="pt-0 pl-15 pr-0 bills">
          <v-expand-transition>
            <v-card v-show="expand" tile flat>
              <BaseTableView :head="billHead" class="bill_table">
                <StatisticProjectReportsTableBill
                  v-for="(bill, b) in bills"
                  :key="'bill' + b"
                  :item="bill"
                  :delete-item="deleteBill"
                  :project="workClientProjectShow"
                />
              </BaseTableView>
            </v-card>
          </v-expand-transition>
        </td>
      </tr>
    </template>
    <v-dialog v-model="dialog" width="600">
      <v-card class="px-4 py-12 pa-md-10">
        <v-btn icon text absolute right top @click="dialog = false" class="ma-n1">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div v-if="bills && bills.length > 0">
          <StatisticProjectReportsTableBill
            v-for="(bill, b) in bills"
            :key="'bill' + b"
            :item="bill"
            :delete-item="deleteBill"
            :project="workClientProjectShow"
            min-table
          />
        </div>
        <Plug v-else/>
      </v-card>
    </v-dialog>
  </BaseTableView>
</template>

<script>
import StatisticProjectReportsTableItem from 'components/timeControl/reports/StatisticProjectReportsTableItem'
import {mapActions, mapGetters} from 'vuex'
import StatisticProjectReportsTableBill from "./StatisticProjectReportsTableBill";
import Plug from "../../Plug";

export default {
  name: 'StatisticProjectReportsTable',
  props: {items: [Array, Object], function_dataList: Function},
  components: {
    Plug,
    StatisticProjectReportsTableBill,
    StatisticProjectReportsTableItem,
  },
  data: () => ({
    dialog: false,
    search: '',
    deleteId: null,
    bills: null,
    showBills: -1,
    expand: false,
    minTable: false,
  }),
  computed: {
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages.projects['reports_table'].period,
          sort: {
            name: 'start_date',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'start_date'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages.projects['reports_table']['week_number'],
        },
        {
          text: this.localStorage.translations.pages.projects['reports_table']['date_create'],
          sort: {
            name: 'created_at',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'created_at'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true}
      ]
    },
    billHead() {
      return [
        {
          text: this.localStorage.translations.pages.projects['reports_table']['sent-date'],
        },
        {
          text: this.localStorage.translations.pages.projects['reports_table']['received-date'],
        },
        {text: '', active: true}
      ]
    },
  },
  created() {
    this.onWorkClientProjectShow(this.$route.params.id)
  },
  methods: {
    ...mapActions('workClientProjectsClientReports', [
      'onWorkClientProjectsClientReportsBillGrid',
      'onWorkClientProjectsClientReportsBillDelete'
    ]),
    ...mapActions('workClientProject', ['onWorkClientProjectShow']),
    async openBillsTable(id, dontclose) {
      this.expand = false
      if (this.showBills === id && !dontclose) this.showBills = -1
      else await this.onWorkClientProjectsClientReportsBillGrid({report: id}).then(res => {
        this.bills = res.data.data
        this.showBills = id
        setTimeout(() => {
          this.expand = true
        }, 0)
      })
    },
    async openBillsModal(id) {
      await this.onWorkClientProjectsClientReportsBillGrid({report: id}).then(res => {
        this.bills = res.data.data
        this.showBills = id
        setTimeout(() => {
          this.dialog = true
        }, 0)
      })
    },
    async deleteBill(id) {
      await this.onWorkClientProjectsClientReportsBillDelete({id: id})
        .then(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'], IsError: false},
            {root: true},
          )
          this.openBillsTable(this.showBills, true)
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.localStorage.translations.pages.common.notifications['oshibka'], IsError: true},
            {root: true},
          )
        })
    },
    onMin(value) {
      this.minTable = value
    }
  }
}
</script>

<style lang="scss">
.rel {
  border: none !important;
  min-height: 0 !important;
  
  &:hover {
    background-color: transparent !important;
  }
}

.icon {
  margin: -10px !important;
}

:deep() th {
  background-color: white !important;
}

.table {
  thead {
    z-index: 3 !important;
  }
}

.table > tbody > tr > td {
  
  &:nth-child(1) {
    width: 200px !important;
  }
  &:nth-child(2) {
    width: 300px !important;
  }
  &:nth-child(3) {
    width: 100px !important;
  }
  &:nth-child(4) {
    width: 100px !important;
  }
}

.bill_table {
  thead {
    top: 179px !important;
    z-index: 2 !important;
  }
}

.bills {
  border-left: none !important;
  border-right: none !important;
}
</style>
